<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <a-form
    class="form form-search"
    layout="inline"
    :model="modelRef"
    @finish="onFinish"
    @finishFailed="onFinishFailed"
  >
    <a-form-item label="用户名称" name="value1">
      <a-input placeholder="请输入用户名称" v-model:value="modelRef.value1" />
    </a-form-item>
    <a-form-item label="用户来源" name="value3">
      <a-select
        placeholder="请选择用户来源"
        dropdownClassName="search-select-dropdown"
        v-model:value="modelRef.value3"
      >
        <a-select-option value="招商云">招商云</a-select-option>
        <a-select-option value="云启">云启</a-select-option>
        <a-select-option value="高效机房">高效机房</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="注册时间" name="value5">
      <a-range-picker v-model:value="modelRef.value5" />
    </a-form-item>

    <div class="btns">
      <a-button class="button-primary" @click="onFinish">查询</a-button>
      <a-button class="m-l button-base" @click="reset">重置</a-button>
    </div>
  </a-form>
</template>

<script>
import { reactive, toRaw } from "vue";
import { Form, Input, Button, DatePicker, Select } from "ant-design-vue";
const FormItem = Form.Item;
const useForm = Form.useForm;
const RangePicker = DatePicker.RangePicker;

export default {
  name: "user-index-search",
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [RangePicker.name]: RangePicker,
    [Button.name]: Button,
    [Select.name]: Select,
    ASelectOption: Select.Option
  },
  emits: ["onGetList"],
  setup(props, context) {
    const modelRef = reactive({
      value1: "",
      value3: undefined,
      value5: []
    });
    const searchList = reactive([
      {
        name: "value1"
      },
      {
        name: "value3"
      },
      {
        name: "value5"
      }
    ]);

    const { resetFields } = useForm(modelRef);
    const onFinish = () => {
      const values = getValues();
      context.emit("onGetList", values);
    };

    const getValues = () => {
      const values = toRaw(modelRef);
      values.beginvalue5 = "";
      values.endvalue5 = "";
      if (Array.isArray(values.value5) && values.value5[0]) {
        values.beginvalue5 = values.value5[0].format("YYYY-MM-DD");
        values.endvalue5 = values.value5[1].format("YYYY-MM-DD");
      }
      return values;
    };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };

    const reset = () => {
      resetFields();
      context.emit("onGetList", {});
    };

    const formItemLayout = {
      wrapperCol: {
        span: 24
      }
    };

    return {
      modelRef,
      onFinish,
      onFinishFailed,
      reset,
      getValues,
      searchList,
      formItemLayout
    };
  }
};
</script>
